import React from 'react';
import ReactDOM from 'react-dom';

const ConfirmBox = ({ isOpen, message, image, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
        <div style={{ background: '#ffffff', padding: '24px', borderRadius: '8px', width: '90%', maxWidth: '300px', textAlign: 'center' }}>
            {image && (
                <img src={image} alt="" style={{ display: 'block', margin: '0 auto 16px', maxWidth: '100%', maxHeight: '160px', objectFit: 'contain', borderRadius: '8px' }} />
            )}
            <p style={{ marginBottom: '16px', fontSize: '16px', color: '#000' }}>
                {message}
            </p>
            <div style={{ display: 'flex', gap: '8px' }}>
                <button onClick={onConfirm} style={{ flex: 1, padding: '12px', background: '#AE3041', color: '#ffffff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>Confirm</button>
                <button onClick={onCancel} style={{ flex: 1, padding: '12px', background: '#f5f5f5', color: '#000', border: '1px solid #e0e0e0', borderRadius: '8px', cursor: 'pointer' }}>Cancel</button>
            </div>
        </div>
    </div>
  );
};

export default ConfirmBox;